const MINUTE_UNITS = ['minuto', 'minutos', 'minute', 'minutes', 'minuten', 'minuti', 'minuut', 'minut', 'fun', 'pun'];
const HOUR_UNITS = ['hora', 'horas', 'hour', 'hours', 'stunde', 'stunden', 'ora', 'ore', 'uur', 'uren', 'chas', 'chasa', 'chasov'];
const SECOND_UNITS = ['segundo', 'segundos', 'second', 'seconds', 'seconde', 'secondes', 'sekunde', 'sekunden', 'secondi', 'seconden', 'sekund', 'sekundy', 'byou'];

const LONG_TAIL_PREFIX_REGEX = /^(?:timer|temporizador|minuteur)-(\d+)-([a-z]+)$/i;
const LONG_TAIL_SUFFIX_REGEX = /^(\d+)-([a-z]+)-(?:timer|temporizador|minuteur)$/i;

const parseTimerFromPath = (props) => {
    try {
        let paramPath = null;
        if (props && props.match && props.match.params && props.match.params.param) {
            paramPath = props.match.params.param;
        } else if (props && props.location && props.location.pathname) {
            const cleanPath = props.location.pathname.split('?')[0].split('#')[0];
            const segments = cleanPath.split('/').filter(Boolean);
            if (segments.length === 1 && !['stopwatch', 'focus', 'terms', 'privacy', 'en', 'pt', 'es', 'fr', 'it', 'ru', 'de', 'nl', 'ja'].includes(segments[0].toLowerCase())) {
                paramPath = segments[0];
            } else if (segments.length >= 2) {
                paramPath = segments[1];
            }
        }

        if (!paramPath) {
            return { hour: 0, minute: 0, second: 0 };
        }

        paramPath = decodeURI(paramPath).toLowerCase();

        // 1. Verificação Cauda Longa (Ex: timer-5-minutos, minuteur-10-minutes, timer-1-minute)
        const prefixMatch = paramPath.match(LONG_TAIL_PREFIX_REGEX);
        const suffixMatch = !prefixMatch ? paramPath.match(LONG_TAIL_SUFFIX_REGEX) : null;
        const matched = prefixMatch || suffixMatch;

        if (matched) {
            const val = parseInt(matched[1], 10);
            const unit = matched[2].toLowerCase();

            if (isNaN(val) || val <= 0) {
                throw new Error('Invalid Parameters');
            }

            if (MINUTE_UNITS.includes(unit)) {
                if (val > 180) throw new Error('Limit reached');
                return { hour: Math.floor(val / 60), minute: val % 60, second: 0 };
            }

            if (HOUR_UNITS.includes(unit)) {
                if (val > 24) throw new Error('Limit reached');
                return { hour: val, minute: 0, second: 0 };
            }

            if (SECOND_UNITS.includes(unit)) {
                if (val >= 60) throw new Error('Limit reached');
                return { hour: 0, minute: 0, second: val };
            }

            throw new Error('Invalid Parameters');
        }

        // 2. Verificação de Formato Composto / Legado (Ex: 5-minutes-timer, 1-hour-5-minutes-30-seconds-timer)
        let tmpParam = paramPath.split('-');
        if (tmpParam.length !== 3 && tmpParam.length !== 5 && tmpParam.length !== 7) {
            throw new Error('Invalid Parameters');
        }
        if (isNaN(tmpParam[0]) || parseInt(tmpParam[0], 10) === 0) {
            throw new Error('Invalid Parameters');
        }
        if ((tmpParam.length === 5 || tmpParam.length === 7) && (isNaN(tmpParam[2]) || parseInt(tmpParam[2], 10) === 0)) {
            throw new Error('Invalid Parameters');
        }
        if (tmpParam.length === 7 && (isNaN(tmpParam[4]) || parseInt(tmpParam[4], 10) === 0)) {
            throw new Error('Invalid Parameters');
        }
        if (tmpParam[tmpParam.length - 1] !== 'timer') {
            throw new Error('Invalid Parameters');
        }

        tmpParam[0] = parseInt(tmpParam[0], 10);
        if (tmpParam.length >= 5) tmpParam[2] = parseInt(tmpParam[2], 10);
        if (tmpParam.length === 7) tmpParam[4] = parseInt(tmpParam[4], 10);

        if (tmpParam.length === 3 && (
            (tmpParam[0] === 1 && (tmpParam[1] !== 'minute' && tmpParam[1] !== 'hour' && tmpParam[1] !== 'second')) ||
            (tmpParam[0] > 1 && (tmpParam[1] !== 'minutes' && tmpParam[1] !== 'hours' && tmpParam[1] !== 'seconds'))
        )) {
            throw new Error('Invalid Parameters');
        }

        let timerFromPath = { hour: 0, minute: 0, second: 0 };

        if (tmpParam.length === 3) {
            if (tmpParam[1] === 'hour' || tmpParam[1] === 'hours')
                timerFromPath = { ...timerFromPath, hour: tmpParam[0] };
            else if (tmpParam[1] === 'minute' || tmpParam[1] === 'minutes')
                timerFromPath = { ...timerFromPath, minute: tmpParam[0] };
            else
                timerFromPath = { ...timerFromPath, second: tmpParam[0] };
        } else if (tmpParam.length === 5) {
            if (tmpParam[1] === 'hour' || tmpParam[1] === 'hours')
                timerFromPath = { ...timerFromPath, hour: tmpParam[0] };
            else if (tmpParam[1] === 'minute' || tmpParam[1] === 'minutes')
                timerFromPath = { ...timerFromPath, minute: tmpParam[0] };

            if (tmpParam[3] === 'minute' || tmpParam[3] === 'minutes')
                timerFromPath = { ...timerFromPath, minute: tmpParam[2] };
            else
                timerFromPath = { ...timerFromPath, second: tmpParam[2] };
        } else {
            timerFromPath = { hour: tmpParam[0], minute: tmpParam[2], second: tmpParam[4] };
        }

        if (timerFromPath.hour > 24) {
            throw new Error('Invalid Parameters');
        }

        // Limites do formato legado
        if (tmpParam.length === 3) {
            if (tmpParam[1] === 'hour' || tmpParam[1] === 'hours') {
                const hoursOk = [1, 2, 5];
                if (!hoursOk.includes(tmpParam[0])) throw new Error('limit reached');
            }
            if (tmpParam[1] === 'minute' || tmpParam[1] === 'minutes') {
                const minutesOk = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 18, 19, 20, 22, 23, 25, 26, 28, 29, 30, 31, 35, 36, 39, 40, 43, 45, 50];
                if (!minutesOk.includes(tmpParam[0])) throw new Error('limit reached');
            }
            if (tmpParam[1] === 'second' || tmpParam[1] === 'seconds') {
                throw new Error('limit reached');
            }
        }
        if (tmpParam.length === 5) {
            throw new Error('limit reached');
        }

        return timerFromPath;
    } catch (e) {
        return false;
    }
};

export default parseTimerFromPath;